import React, { Component } from "react";
import * as GlobalStyle from "../CSSStyles";
import emptyBagIcon from "./../assets/images/icons/ic_empty_bag.svg";

class PageDoesntExist extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div style={{ minHeight: "calc(100vh - 100px)" }}>
        <GlobalStyle.EmptyBagStyle style={{ padding: "2rem" }}>
          <img src={`${emptyBagIcon}`} />
          <h1 style={{ fontSize: "3rem" }}>Oops. You’re lost in Cambridge.</h1>
          <p style={{ fontSize: "1.8rem", fontWeight: "regular" }}>
            Error 404. Page not found.
          </p>
          <br />
          <a
            // href={"#" + this.props.data.bagPagePath}
            href={"/"}
            className="link-as-btn"
            style={{ maxWidth: "260px" }}
          >
            Back to homepage
          </a>
        </GlobalStyle.EmptyBagStyle>
      </div>
    );
  }
}
export default PageDoesntExist;
